<template>
  <div :class="$vuetify.breakpoint.smAndUp ? 'padding' : ''"
       class="edit-section">

    <div class="semanticsection-title2 primary--text">
      {{ title }}
      <slot name="title-addition" />
    </div>

    <slot :userForm="userForm" />

    <div v-if="!registerMode"
              class="ma-0 mt-6">
      <v-btn :disabled="disableButtons"
             class="ma-0 mr-10"
             @click="$emit('cancel')">Abbrechen
      </v-btn>
      <v-btn :disabled="!dataChanged || disableButtons"
             class="ma-0"
             color="primary"
             @click="saveChanges">Speichern
      </v-btn>
    </div>

  </div>
</template>
<script>
export default {
  name: "EditSection",
  props: {
    title: {
      type: String,
      required: true
    },
    keys: {
      type: Array,
      default: function () {
        return [];
      }
    },
    user: {
      type: Object,
      default: null
    },
    registerMode: {
      type: Boolean,
      required: false,
      default: false
    },
    disableButtons: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      userForm: {},
      dataChanged: true // default true to allow save in Änderungsantrag, that page uses editSection in a different way
    };
  },
  computed: {
    formRef: function () {
      return this.$children.filter(child => child.$refs.editForm)[0];
    }
  },
  created() {
    if (this.user) {
      let getValue = (key) => {
        switch (key) {
          case 'staat':
            return this.user.staat ? this.user.staat : 'Deutschland';
          default:
            return this.user[key];
        }
      };
      this.keys.forEach(key => {
        this.$set(this.userForm, key, getValue(key));
      });
      this.dataChanged = false;
      this.$watch("userForm", () => this.dataChanged = true, { deep: true });
    }
  },
  methods: {
    saveChanges: function () {
      const validations = this.getAllValidators(this.formRef).map(v => v.validateAll());
      Promise.all(validations)
        .then(result => {
          if (result.includes(false)) {
            throw new Error('Validation Error');
          }
          this.$emit('update-profile', this.userForm);
        })
        .catch(() => {
          this.$emit('error');
        });

    },
    getAllValidators(comp) {
      let validators = [];

      function collectValidators(component) {
        if (component.$validator) {
          validators.push(component.$validator);
        }
        if (component.$children) {
          component.$children.forEach(collectValidators);
        }
      }

      collectValidators(comp);
      return validators;
    }
  }
};
</script>
<style>
.edit-section {
  width: 100%;
}

.edit-section.padding .edit-form:not(.edit-info-form):not(edit-firma-form).row > div[class*=col-]:nth-child(odd):not(.semanticsection-title2):not(.custom-label-radiogroup):not(.custom-label-inputgroup) {
  padding-right: 40px;
}

.edit-section.padding .edit-form:not(.edit-info-form):not(edit-firma-form).row > div[class*=col-]:nth-child(even):not(.semanticsection-title2):not(.custom-label-radiogroup):not(.custom-label-inputgroup) {
  padding-left: 40px;
}

.edit-section .v-input:not(.v-input--selection-controls):not(.v-input--radio-group) {
  max-width: 344px;
}
</style>
